<ng-select
  *transloco="let t"
  [items]="items$ | async"
  bindLabel="title"
  bindValue="id"
  [ngModel]="value"
  (change)="select($event)"
  (blur)="onTouched()"
  [addTag]="addTag"
  [addTagText]="t('gradebook/thematicBlock/create')"
  [notFoundText]="t('gradebook/thematicBlock/notFound')"
  [placeholder]="placeholder"
  [clearable]="clearable"
  [disabled]="disabled"
  [labelForId]="labelForId"
  [ngClass]="{ 'is-invalid': invalid }"
  class="form-control"
  appendTo="body"
></ng-select>
